import React, { CSSProperties } from "react";
import * as styles from "./velavu-inline-select.module.scss";
import { classArr } from "../helper/style-helper";

export interface VelavuInlineSelectProps<T> {
	className?: string;
	style?: CSSProperties;
	children?: React.ReactNode;

	value?: T;
	onChange?: (value: T) => void;
	disabled?: boolean;
}

// A compact select that sizes to its content
export default function VelavuInlineSelect<T extends string>(
	props: VelavuInlineSelectProps<T>,
): React.ReactNode;
export default function VelavuInlineSelect<T extends number>(
	props: VelavuInlineSelectProps<T>,
): React.ReactNode;
export default function VelavuInlineSelect<T extends string | number>(
	props: VelavuInlineSelectProps<T>,
) {
	return (
		<select
			style={props.style}
			className={classArr(props.className, styles.select)}
			value={props.value}
			onChange={(event) =>
				props.onChange?.(
					(typeof props.value === "number"
						? Number(event.target.value)
						: event.target.value) as T,
				)
			}
			disabled={props.disabled}
		>
			{props.children}
		</select>
	);
}
